import { combineReducers } from "redux";

export function error(state = null, action) {
  switch (action.type) {
    case "LOGIN_ERROR":
      return action.error;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case "LOGIN_LOADING":
      return action.loading;

    default:
      return state;
  }
}

export function logged(state = null, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return action.logged;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, logged });
